var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 44.99 44.99",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.558,43.886c0.041-0.282-0.019-0.582-0.188-0.834L30.51,35.97c0.121,0.072,0.275,0.074,0.397-0.012 c0.168-0.117,0.209-0.347,0.095-0.515l-1.687-2.422c-0.115-0.168-0.344-0.209-0.512-0.092c-0.113,0.078-0.162,0.207-0.15,0.334 l-4.981-7.26v-3.166c0.644-0.297,1.093-0.944,1.093-1.698c0-0.754-0.449-1.399-1.093-1.697V3.013h0.759 c0.832,0,1.508-0.674,1.508-1.506S25.263,0,24.431,0h-3.877c-0.832,0-1.506,0.675-1.506,1.507s0.674,1.506,1.506,1.506h0.166 l-5.428,6.168c-0.447-0.214-0.91-0.196-1.156,0.083l-2.039,2.32c-0.326,0.372-0.145,1.064,0.408,1.55l0.115,0.103 c0.551,0.483,1.264,0.576,1.588,0.204l2.039-2.319c0.245-0.28,0.202-0.743-0.066-1.161l5.133-5.834v15.316 c-0.643,0.298-1.094,0.944-1.094,1.698c0,0.754,0.451,1.4,1.094,1.698v3.166l-4.999,7.283c0.021-0.136-0.032-0.275-0.149-0.357 c-0.168-0.116-0.396-0.075-0.515,0.093l-1.684,2.422c-0.117,0.168-0.076,0.396,0.092,0.514c0.137,0.096,0.313,0.08,0.437-0.02 l-4.881,7.11c-0.175,0.254-0.23,0.554-0.189,0.834c-0.965,0.093-1.639,0.293-1.639,0.524c0,0.32,1.254,0.58,2.803,0.58 c1.547,0,2.803-0.26,2.803-0.58c0-0.223-0.611-0.411-1.496-0.51l9.418-13.727v10.279c0,0.137,0.029,0.266,0.072,0.389 c-0.996,0.09-1.693,0.293-1.693,0.533c0,0.32,1.254,0.58,2.802,0.58c1.549,0,2.803-0.26,2.803-0.58c0-0.24-0.697-0.443-1.693-0.533 c0.043-0.123,0.072-0.252,0.072-0.389V30.173L33.095,43.9c-0.887,0.098-1.496,0.287-1.496,0.51c0,0.32,1.256,0.58,2.803,0.58 c1.549,0,2.803-0.26,2.803-0.58C37.196,44.177,36.522,43.977,35.558,43.886z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStab);
export default __webpack_public_path__ + "static/media/stab.f62d13a394b478aee550d7c5e282594b.svg";
export { ForwardRef as ReactComponent };